<template>
  <div id="app">
    <lemon-imui class="chat-window" width="100vw" height="100vh" simple :user="user" ref="IMUI"
      @message-click="handleMessageClick" @send="handleSend" @pull-messages="handlePullMessages"
      @showContactInfo="showContactInfo">
      <template #cover>
        <div class="cover">
          <span><b>智岚</b> 客服系统</span>
        </div>
      </template>
    </lemon-imui>

    <!-- 填写联系信息框 -->
    <van-popup v-model="show">
      <div class="content">
        <div class="title">请填写联系信息</div>
        <div class="info">
          <van-cell-group>
            <van-field v-model="memberDetail.memberRealName" label="称呼" placeholder="请输入称呼" />
            <van-field v-model="memberDetail.memberWx" label="微信" placeholder="请输入微信" />
            <van-field v-model="memberDetail.memberQq" label="qq" placeholder="请输入qq" />
            <van-field v-model="memberDetail.memberPhone" label="电话" placeholder="请输入电话" />
            <van-field v-model="memberDetail.memberEmail" label="邮箱" placeholder="请输入邮箱" />
          </van-cell-group>
        </div>
        <div class="button">
          <van-button type="info" size="small" @click="saveMemberInfo">保存</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  const getTime = () => new Date().getTime();
  const generateRandId = () => Math.random().toString(36).substr(-8);

  //var ws = null;

  import { createChatSession, getHistoryMessage, getMemberDetail, updateMemberInfo } from "@/api/chat.js";
  export default {
    name: "App",
    components: {},
    data() {
      return {
        // 用户信息
        user: {
          id: 0,
          displayName: null,
          avatar: "",
        },
        serviceContent: {},
        // 消息记录
        messages: [],

        // IMUI组件实例
        IMUI: null,
        isLogin: false,
        notifications: [],
        pageContent: {
          pageIndex: 0,
          pageSize: 10,
          totalNum: 0,
          totalPage: 1,
        },
        show: false,
        memberContent: null,
        ws: null,

        // 获取会话参数
        sessionParams: {
          customerId: "",
          pageIndex: 0,
          pageSize: 0,
          token: "",
        },

        memberId: "",
        memberDetail: {
          name: "",
          wechat: "",
          qq: "",
          phone: "",
          email: "",
        },
      };
    },

    mounted() {
      // 监听websocket消息

      // 聊天ui对象
      const { IMUI } = this.$refs;
      this.IMUI = IMUI;

      // 请求浏览器授权
      if (typeof Notification != 'undefined')
        Notification.requestPermission();

      this.initWebSocket();
      this.init();
    },

    methods: {
      //初始化webSocket
      initWebSocket() {

        this.ws = new WebSocket(process.env.VUE_APP_WEBSOCKET_URL);
        this.ws.addEventListener("message", this.handleWsMessage.bind(this), false);
        this.ws.addEventListener("open", this.handleWsOpen.bind(this), false);
      },
      init() {
        // 从url获取客户id
        this.sessionParams.customerId = this.$route.query.customerId || "";

      },

      getMemberDetail() {
        getMemberDetail(this.memberId).then(res => {
          console.log("游客详情", res);
          if (res.code == 200) {
            this.memberDetail = res.data;
          }
        })
      },

      // 获取会话参数
      createChatSession() {
        var that = this;

        const memberData = JSON.parse(localStorage.getItem("memberData"));

        // 超时时间，30日
        const expire = 30 * 24 * 60 * 60 * 1000;

        // 超过多少时间重新获取最新的token
        if (memberData && new Date().getTime() - memberData.time > expire) {
          localStorage.removeItem("memberData");
          this.sessionParams.token = "";
        } else {
          this.sessionParams.token = memberData ? memberData.memberToken : "";
        }
        // 调用接口
        createChatSession(this.sessionParams).then((res) => {
          console.log("会话", res);
          if (res.code == 200) {
            var data = res.data;
            that.serviceContent = data.serviceContent;
            that.memberContent = data.memberContent;
            that.user.displayName = data.memberContent.memberRealName || data.memberContent.memberName;
            that.user.id = data.memberContent.memberId;
            that.isLogin = data.memberContent.memberId > 0;
            that.memberId = data.memberContent.memberId;

            //alert( this.ws.readyState);
            //发起握手
            that.shakeHands();

            localStorage.setItem(
              "memberData",
              JSON.stringify({
                // 存入token
                memberToken: res.data.memberContent.memberToken,
                // 存入时间
                time: new Date().getTime(),
              })
            );

            that.getMemberDetail();
          }
        });
      },

      // 点击消息事件
      handleMessageClick(e, key, message) {
        console.log("点击消息事件:e", e);
        console.log("点击消息事件:key", key);
        console.log("点击消息事件:message", message);



        const { IMUI } = this.$refs;
        if (key == "status" && message.status === "failed") {
          IMUI.updateMessage({
            id: message.id,
            toContactId: message.toContactId,
            status: "going",
            content: "重新发送消息...",
          });
          setTimeout(() => {
            IMUI.updateMessage({
              id: message.id,
              toContactId: message.toContactId,
              status: "failed",
              content: "还是发送失败",
            });
          }, 2000);
        }
        else {
          if (message.type == "image") {
            this.$imagePreview({ images: [message.content], closeable: true });
          }
        }
      },
      //握手webSocket 连接， 认证用户身份
      shakeHands() {
        var sendContent = {
          action: "Shakehands",
          type: 1,
          userId: this.memberContent.memberId,
        };

        this.ws.send(JSON.stringify(sendContent));
      },
      // 发送消息操作
      handleSend(message, next, file) {

        // 调用接口
        // axios.post('http://127.0.0.1:8098/send', message).then(res => {
        //   next();
        // }).catch(err => {
        //   next({ status: 'failed' })
        // })

        // 或前端发送
        var sendContent = {
          action: "sendMessage",
          type: 1,
          messageContent: message,
        };

        this.ws.send(JSON.stringify(sendContent));
        next();
      },

      // 初始化消息记录
      handlePullMessages(contact, next) {
        if (this.isLogin == true) {
          this.pageContent.pageIndex++;
          var params = {
            pageIndex: this.pageContent.pageIndex,
            pageSize: this.pageContent.pageSize,
            userId: this.memberContent.memberId,
            friendId: this.serviceContent.customerId,
          };
          var messages = [];
          getHistoryMessage(params).then((res) => {
            if (res.code == 200) {
              var rows = res.data.result;
              this.pageContent.totalNum = res.data.totalNum;
              this.pageContent.totalPage = res.data.totalPage;
              rows.forEach(element => {
                messages.unshift(element);
              });


              var isEnd = this.pageContent.pageIndex >= res.data.totalPage;
              next(messages, isEnd);
            }
          });
        }

      },
      handleWsOpen(e) {
        this.createChatSession();
      },
      // websocket监听消息事件
      handleWsMessage(e) {
        const message = JSON.parse(e.data);
        console.log("接收到的消息", message);
        //接口返回正常
        if (message.code == 200) {
          if (message.data.action == "Shakehands") {
            this.IMUI.initContacts([
              {
                id: this.serviceContent.customerId,
                displayName: this.serviceContent.customerCompany,
                avatar: "",
                type: "single",
                index: "1T",
                unread: 0,
                lastSendTime: getTime(),
                lastContent: "",
              },
            ]);

            setTimeout(() => {
              this.IMUI.changeContact(this.serviceContent.customerId);
            }, 1000);
          } else if (message.data.action == "send-client-message") {
            var recMsg = message.data.data;

            recMsg.status = "succeed";

            // 如果来源人不是当前用户，则添加到聊天窗口
            //if (message.fromUser.id !== this.user.id) {
            this.IMUI.appendMessage(recMsg, true);
            //}
            if (typeof Notification != 'undefined') {
              // 在浏览器中显示通知
              new Notification(
                `智岚客服系统提醒您，${recMsg.fromUser.displayName}给您发来一条消息`
              );
            }

          }
        } else {
          alert(message.msg);
          return;
        }
      },

      // 填写聊天方式弹窗
      showContactInfo() {
        this.show = true;
      },

      // 保存用户信息
      saveMemberInfo() {
        this.$dialog.alert({
          title: "提示",
          message: "是否确认保存？",
          showCancelButton: true,
        }).then(res => {
          updateMemberInfo(this.memberDetail).then(res => {
            if (res.code == 200) {
              this.user.displayName = this.memberDetail.memberRealName;
              this.$toast({
                message: "保存成功",
                duration: 1500
              });
              setTimeout(() => {
                this.show = false;
              }, 1500);
            }
          })
        });
      }
    },

    beforeDestroy() {
      this.ws.close();
    },
  };
</script>

<style lang="less" scoped>
  #app {
    :deep(.lemon-editor__input) {}

    .content {
      width: 90vw;

      .title {
        padding: 15px;
        text-align: left;
      }

      .info {
        padding: 0 5px;
      }

      .button {
        text-align: right;
        padding: 15px;
      }
    }
  }
</style>